import { TextField } from '@mui/material';
import styled from 'styled-components';
import { muiTheme } from '../../../theme';

export const StyledTextField = styled(TextField)`
  & .MuiInputLabel-outlined {
    top: 0px;
    transform: ${({ theme: { spacing } }) => `translate(${spacing(3.5)}, ${spacing(1.5)}) scale(1)`};
  }
  & .MuiInputLabel-outlined.MuiFormLabel-filled {
    transform: translate(14px, -9px) scale(0.75);
  }
  & .MuiInputLabel-outlined.Mui-focused {
    color: ${({
      theme: {
        color,
        palette: { mode },
      },
    }) => (mode === 'dark' ? color.white : color.textGray)};
    transform: ${({ theme: { spacing } }) => `translate(${spacing(3.5)}, ${spacing(-2.25)}) scale(0.75)`};
  }
  & .MuiOutlinedInput-root {
    padding: 0px;
  }
  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: ${({
        theme: {
          color,
          palette: { mode },
        },
      }) => (mode === 'dark' ? color.white : color.borderGray)};
    }
  }
  & .MuiInputBase-input {
    font-family: ${muiTheme.typography.body2.fontFamily};
    font-size: ${muiTheme.typography.body2.fontSize};
    font-weight: ${muiTheme.typography.body2.fontWeight};
  }
`;
